/* eslint-disable import/prefer-default-export */

/**
 * Formats currency like Shopify filter
 * @param {number} price In cents - straight from Shopify
 * @param {string} locale Locale code. From Shopify global it is `Shopify.locale`.
 * @param {string} country The ISO two digit country code. From Shopify global it is `Shopify.country`.
 * @param {string} currency The ISO three digit code. From Shopify global it is `Shopify.currency`.
 * @returns {string} The formatted currency. Follows format of Shopify's money filter
 */
export function currencyFormatter(
  price,
  locale = 'en',
  country = 'US',
  currency = 'USD',
  options = {}
) {
  const formatter = new Intl.NumberFormat(`${locale}-${country}`, {
    style: 'currency',
    currency,
  });
  const parts = formatter.formatToParts(price / 100);
  let str = `${parts[0].value} ${parts[1].value}`;
  if (options.displayCents) {
    str += `${parts[2].value}${parts[3].value}`;
  }
  return str;
}
